import _objectSpread from "@babel/runtime/helpers/objectSpread2";
var _FacebookLogo, _LoadingOverlay;
import { CREHANA_BASE_URL_PRD } from "@crehana/constants";
import FacebookLogo from "@crehana/icons/FacebookLogo";
import GoogleIcon from "@crehana/icons/GoogleIcon";
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { colors } from "@crehana/ui";
import LoadingOverlay from "../../LoadingOverlay";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SocialButtonsVariantMinimalV2 = function SocialButtonsVariantMinimalV2(_ref) {
  var shouldRenderFacebookButton = _ref.shouldRenderFacebookButton,
    facebookButtonProps = _ref.facebookButtonProps,
    gmailButtonProps = _ref.gmailButtonProps,
    processingSocialAuth = _ref.processingSocialAuth,
    loadingFacebookAndGoogleScripts = _ref.loadingFacebookAndGoogleScripts,
    hideFBAuthButton = _ref.hideFBAuthButton,
    hideFBAuthLink = _ref.hideFBAuthLink,
    nextUrl = _ref.nextUrl;
  var renderFBAuth = function renderFBAuth() {
    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (hideFBAuthButton && hideFBAuthLink) return null;
    if (hideFBAuthButton && !hideFBAuthLink) {
      return /*#__PURE__*/_jsx("div", {
        className: "flex items-center justify-center w-48 h-48 bg-white rounded-full",
        children: /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({
          href: "".concat(CREHANA_BASE_URL_PRD, "/login/facebook/?next=").concat(nextUrl)
        }, facebookButtonProps), {}, {
          children: /*#__PURE__*/_jsx(FacebookLogo, {
            size: 28,
            color: colors.white
          })
        }))
      });
    }
    return /*#__PURE__*/_jsx("div", {
      className: "flex items-center justify-center w-48 h-48 bg-white rounded-full",
      children: /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread({
        className: "flex",
        type: "button"
      }, facebookButtonProps), {}, {
        children: _FacebookLogo || (_FacebookLogo = /*#__PURE__*/_jsx(FacebookLogo, {
          size: 28
        }))
      }))
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "w-full",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "flex items-center justify-center m-auto max-w-280",
      children: [shouldRenderFacebookButton && renderFBAuth(), /*#__PURE__*/_jsx("div", {
        className: "flex items-center justify-center w-48 h-48 ml-40 bg-white rounded-full",
        children: /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread({
          type: "button",
          style: {
            display: window.navigator.userAgent.toLowerCase().includes('instagram') ? 'none !important' : 'flex'
          }
        }, gmailButtonProps), {}, {
          children: /*#__PURE__*/_jsx(GoogleIcon, {
            size: 28,
            color: colors.white
          })
        }))
      })]
    }), (processingSocialAuth || loadingFacebookAndGoogleScripts) && (_LoadingOverlay || (_LoadingOverlay = /*#__PURE__*/_jsx(LoadingOverlay, {})))]
  });
};
export default SocialButtonsVariantMinimalV2;